import React from 'react'
import { ProgressBar } from "primereact/progressbar";
import { Tooltip } from "primereact/tooltip";

function Progreso({ item, listaProgresoLeccionUnidadeCursoPrograma, listaLeccionUnidadeCursoPrograma, listaUnidadeCursoPrograma, listaEvaluacionesUnidadeCursoPrograma, CursoEvaluacion }) {
    
    function ProgresoProgramaCursoPormedioProgressBar(props) {
        const uniqueClassName = `Tooltiptrue-${props.idCurso}`;

        if (listaProgresoLeccionUnidadeCursoPrograma != null) {
            var Sum = listaProgresoLeccionUnidadeCursoPrograma
                .filter((x) => x.idCurso === props.idCurso)
                .reduce((sum, item) => sum + item.PorcentajeAvance, 0);
            var UnidadesPorCurso = listaUnidadeCursoPrograma.filter(
                (x) => x.idCurso === props.idCurso
            );
            var auxListadeLeccionesPorUnidad = [];
            var evaluacionCurso = 0;
            for (var i = 0; i < UnidadesPorCurso.length; i++) {
                var LeccionesPOrUnidad = listaLeccionUnidadeCursoPrograma.filter(
                    (x) => x.idUnidad === UnidadesPorCurso[i].idUnidad
                );
                for (var j = 0; j < LeccionesPOrUnidad.length; j++) {
                    auxListadeLeccionesPorUnidad.push(LeccionesPOrUnidad[j]);
                }
                var evaluacionCursoFilter =
                    listaEvaluacionesUnidadeCursoPrograma.filter(
                        (x) =>
                            x.idUnidad === UnidadesPorCurso[i].idUnidad && x.intento === 1
                    );
                evaluacionCurso = evaluacionCurso + evaluacionCursoFilter.length;
            }
            const PorcentajeCurso = Sum / auxListadeLeccionesPorUnidad.length / 2;
            const evaluacionPorcentaje =
                (evaluacionCurso * 100) / UnidadesPorCurso.length / 2;
            return (
                <>
             

                <ProgressBar
                    style={{ height: "8px", borderRadius: 0, width: "100%" }}
                    color={props.Color ? props.Color : "#FFB62F"}
                    value={(PorcentajeCurso + evaluacionPorcentaje).toFixed()}
                    className={`text-sm `}
                    //className={`text-sm ${props.nombre.length > 28 ? uniqueClassName : ""}`}
                ></ProgressBar>
                {/* <Tooltip
                    target={`.${uniqueClassName}`}
                    content={props.nombre}
                    className="white-tooltip"
                /> */}
                </>
                

            );
        } else {
            return (
                <ProgressBar
                    style={{ height: "8px", borderRadius: 0 }}
                    color="#FFB62F"
                    value={0}
                ></ProgressBar>
            );
        }
    }
    function ProgresoProgramaCursoPormedio(props) {
        if (
            listaProgresoLeccionUnidadeCursoPrograma &&
            listaEvaluacionesUnidadeCursoPrograma
        ) {
            var Sum = listaProgresoLeccionUnidadeCursoPrograma
                .filter((x) => x.idCurso === props.idCurso)
                .reduce((sum, item) => sum + item.PorcentajeAvance, 0);
            var UnidadesPorCurso = listaUnidadeCursoPrograma.filter(
                (x) => x.idCurso === props.idCurso
            );
            var auxListadeLeccionesPorUnidad = [];
            var evaluacionCurso = 0;
            for (var i = 0; i < UnidadesPorCurso.length; i++) {
                var LeccionesPOrUnidad = listaLeccionUnidadeCursoPrograma.filter(
                    (x) => x.idUnidad === UnidadesPorCurso[i].idUnidad
                );
                for (var j = 0; j < LeccionesPOrUnidad.length; j++) {
                    auxListadeLeccionesPorUnidad.push(LeccionesPOrUnidad[j]);
                }
                var evaluacionCursoFilter =
                    listaEvaluacionesUnidadeCursoPrograma.filter(
                        (x) =>
                            x.idUnidad === UnidadesPorCurso[i].idUnidad && x.intento === 1
                    );
                evaluacionCurso = evaluacionCurso + evaluacionCursoFilter.length;
            }
            const PorcentajeCurso = Sum / auxListadeLeccionesPorUnidad.length / 2;
            const evaluacionPorcentaje =
                (evaluacionCurso * 100) / UnidadesPorCurso.length / 2;

            return <span>{(PorcentajeCurso + evaluacionPorcentaje).toFixed()}</span>;
        } else {
            return <span>0.00</span>;
        }
    }

    function Itemcursonombre(props) {
        const uniqueClassName = `Tooltiptrue-${props.idCurso}`;
        return (
            <>
                <b className={`text-sm ${props.nombre.length > 28 ? uniqueClassName : ""}`}>
                    {props.nombre.length > 28? props.nombre.substring(0, 28) + "...":props.nombre}</b>
                <Tooltip
                    target={`.${uniqueClassName}`}
                    content={props.nombre}
                    className="white-tooltip"
                    position="bottom"
                />
            </>
        )
    }

    return (
        <div className="p-fluid formgrid grid ">
            <div className="field col-3  contenedor__avance__progreso" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} >
                {/* <b className="text-sm">
                    {item.curso.nombre}</b> */}
                <Itemcursonombre idCurso={item.idCurso} nombre={item.curso.nombre}/>
            </div>
            <div
                className="field col-5 paddin__avance_progreso_barra__progreso " 
            >
                <ProgresoProgramaCursoPormedioProgressBar
                    idCurso={item.idCurso}  nombre={item.curso.nombre} 
                />
               
            </div>
           
            {/* <div
                className="field col-2 md:col-1 xl:col-1 paddin__avance_progreso_porcentaje__progreso "
            >
                <span className="fontsizesmall ">
                    <ProgresoProgramaCursoPormedio idCurso={item.idCurso} />%
                </span>
            </div>
            <div
                className="field col-6 md:col-3 xl:col-3 paddin__avance_progreso_promedio__progreso "

            >
                <CursoEvaluacion idCurso={item.idCurso} />
            </div> */}
            <div
                className="field col-3 paddin__avance_progreso_porcentaje__progreso "
            >
                <span className="fontsizesmall ">
                    <ProgresoProgramaCursoPormedio idCurso={item.idCurso} />%&nbsp; &nbsp;
                </span>
                <CursoEvaluacion idCurso={item.idCurso} />
            </div>

        </div>
    )
}

export default Progreso